export const workflowInstructionKeys = {
  all: ["workflow-instructions"] as const,
  byWorkflow: (workflowId: string) =>
    [...workflowInstructionKeys.all, workflowId] as const,
} as const;
